import React from 'react';
import { ShieldAlert, Users, FileText, AlertTriangle, Flag, Search, MoreVertical, Ban, CheckCircle } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
export function UserManagementPage() {
  const navItems = [{
    label: 'Verification Queue',
    icon: FileText,
    path: '/admin',
    badge: '12'
  }, {
    label: 'User Management',
    icon: Users,
    path: '/admin/users'
  }, {
    label: 'Disputes',
    icon: Flag,
    path: '/admin/disputes'
  }, {
    label: 'Risk Analysis',
    icon: AlertTriangle,
    path: '/admin/risk'
  }];
  return <DashboardLayout title="Admin Console" personaLabel="ADMIN" personaColor="bg-red-100 text-red-800 border-red-200" navItems={navItems} userInitials="AD" data-id="element-1487">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-1488">
        <h1 className="text-2xl font-bold" data-id="element-1489">User Management</h1>
        <div className="relative w-full md:w-64" data-id="element-1490">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-1491" />
          <input type="text" placeholder="Search users..." className="w-full pl-9 pr-4 py-2 border border-gray-300 text-sm focus:outline-none focus:border-gray-500" data-id="element-1492" />
        </div>
      </div>

      <div className="bg-white border border-gray-300 overflow-hidden" data-id="element-1493">
        <div className="overflow-x-auto" data-id="element-1494">
          <table className="w-full text-left text-sm min-w-[800px]" data-id="element-1495">
            <thead className="bg-gray-50 border-b border-gray-200 font-mono text-xs uppercase text-gray-500" data-id="element-1496">
              <tr data-id="element-1497">
                <th className="p-4 font-bold" data-id="element-1498">User</th>
                <th className="p-4 font-bold" data-id="element-1499">Role</th>
                <th className="p-4 font-bold" data-id="element-1500">Status</th>
                <th className="p-4 font-bold" data-id="element-1501">Joined</th>
                <th className="p-4 font-bold" data-id="element-1502">Activity</th>
                <th className="p-4 font-bold text-right" data-id="element-1503">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1504">
              {[{
              name: 'Rajesh Kumar',
              email: 'rajesh@example.com',
              role: 'Seller',
              status: 'Active',
              joined: 'Oct 12, 2023',
              act: '2 listings'
            }, {
              name: 'Sunrise Developers',
              email: 'contact@sunrise.com',
              role: 'Developer',
              status: 'Verified',
              joined: 'Sep 28, 2023',
              act: '142 plots'
            }, {
              name: 'Amit Shah',
              email: 'amit@test.com',
              role: 'Buyer',
              status: 'Suspended',
              joined: 'Nov 01, 2023',
              act: 'Flagged for spam'
            }, {
              name: 'Priya Singh',
              email: 'priya@nri.com',
              role: 'NRI Buyer',
              status: 'Active',
              joined: 'Oct 15, 2023',
              act: 'POA Pending'
            }].map((user, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1505">
                  <td className="p-4" data-id="element-1506">
                    <div className="font-bold" data-id="element-1507">{user.name}</div>
                    <div className="text-xs text-gray-500" data-id="element-1508">{user.email}</div>
                  </td>
                  <td className="p-4 font-mono text-xs" data-id="element-1509">{user.role}</td>
                  <td className="p-4" data-id="element-1510">
                    <span className={`inline-block px-2 py-1 text-xs font-bold rounded border ${user.status === 'Active' || user.status === 'Verified' ? 'bg-green-100 text-green-800 border-green-200' : 'bg-red-100 text-red-800 border-red-200'}`} data-id="element-1511">
                      {user.status.toUpperCase()}
                    </span>
                  </td>
                  <td className="p-4 text-xs text-gray-500" data-id="element-1512">{user.joined}</td>
                  <td className="p-4 text-xs" data-id="element-1513">{user.act}</td>
                  <td className="p-4 text-right" data-id="element-1514">
                    <div className="flex justify-end gap-2" data-id="element-1515">
                      <button className="p-1.5 hover:bg-gray-200 rounded" title="Verify" data-id="element-1516">
                        <CheckCircle className="w-4 h-4 text-green-600" data-id="element-1517" />
                      </button>
                      <button className="p-1.5 hover:bg-gray-200 rounded" title="Suspend" data-id="element-1518">
                        <Ban className="w-4 h-4 text-red-600" data-id="element-1519" />
                      </button>
                      <button className="p-1.5 hover:bg-gray-200 rounded" data-id="element-1520">
                        <MoreVertical className="w-4 h-4 text-gray-600" data-id="element-1521" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>;
}